var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaymarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.702893 0.585975C0.257663 1.04028 0 1.74758 0 2.66357V35.3363C0 36.2523 0.257663 36.9596 0.702893 37.4139L0.81278 37.5137L19.5958 19.2123V18.7802L0.81278 0.478866L0.702893 0.585975Z",
    fill: "url(#paint0_linear_208_1869)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8498 25.3164L19.5957 19.2129V18.7807L25.8573 12.6772L25.9975 12.7566L33.413 16.8694C35.5292 18.0365 35.5292 19.9571 33.413 21.1317L25.9975 25.237L25.8498 25.3164Z",
    fill: "url(#paint1_linear_208_1869)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9978 25.237L19.596 18.9968L0.703125 37.4145C1.40602 38.1347 2.55225 38.2215 3.85573 37.5013L25.9978 25.237Z",
    fill: "url(#paint2_linear_208_1869)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9978 12.7559L3.85573 0.491624C2.55225 -0.221223 1.40602 -0.134428 0.703125 0.585807L19.596 18.9961L25.9978 12.7559Z",
    fill: "url(#paint3_linear_208_1869)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_1869",
    x1: 17.9281,
    y1: 35.6766,
    x2: -6.85819,
    y2: 10.2483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_1869",
    x1: 36.1687,
    y1: 18.9947,
    x2: -0.505935,
    y2: 18.9947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_208_1869",
    x1: 22.5167,
    y1: 15.6045,
    x2: -11.0955,
    y2: -18.8784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_208_1869",
    x1: -4.05261,
    y1: 48.2838,
    x2: 10.9567,
    y2: 32.8858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaymarket);
export default __webpack_public_path__ + "static/media/playmarket.328207fccb9a19ba7109d079d543ed3f.svg";
export { ForwardRef as ReactComponent };